import React, {ReactNode} from 'react';
import {useFormikContext} from 'formik';

import FormikTextInput from 'src/components/inputs/formik-text-input';
import FormikRadioButtons from 'src/components/formik-radio-buttons';
import InstitutionTypeaheadWithModal from 'shared/institution-typeahead/components/institution-typeahead-with-modal';
import {ActivityForm} from './activities-form-wrapper';

const HighSchoolActivityLocation = () => {
  const formik = useFormikContext<ActivityForm>();

  const locations = [
    {value: 'school', label: 'High School'},
    {value: 'org', label: 'Outside of School'},
  ];

  let selector: ReactNode;
  switch (formik.values.where) {
    case 'school':
      selector = (
        <div className="activity-location-school">
          <InstitutionTypeaheadWithModal institutionType="high-school" fieldName="institution" />
        </div>
      );
      break;
    case 'org':
      selector = (
        <div className="activity-location-organization">
          <FormikTextInput
            name="organization"
            placeholder="e.g. YMCA, Southern League, Upward Bound"
            required
          />
        </div>
      );
      break;
    default:
      selector = null;
      break;
  }

  return (
    <div className="activity-location">
      <FormikRadioButtons
        name="where"
        options={locations}
        legendText="Where did you join this activity?"
        required
      />
      {selector}
    </div>
  );
};

export default HighSchoolActivityLocation;
